import Vue from 'vue'
import Vuex from 'vuex'
import products from './modules/products'
import modal from './modules/modal'
import modalConfirm from './modules/modalConfirm'
import createLogger from 'vuex/logger'
import mutations from './mutations'

const debug = process.env.NODE_ENV !== 'production'
Vue.config.debug = debug

const store = new Vuex.Store({
  state: {
    menu: []
  },
  modules: {
    products,
    modal,
    modalConfirm
  },
  mutations,
  strict: debug,
  middlewares: debug ? [createLogger()] : []
})

if (module.hot) {
  module.hot.accept([
    './mutations',
    './modules/products',
    './modules/modal'
  ], () => {
    const mutations = require('./mutations').default
    const products = require('./modules/products').default
    const modal = require('./modules/modal').default
    store.hotUpdate({
      mutations,
      modules: {
        products,
        modal
      }
    })
  })
}

export default store



/** WEBPACK FOOTER **
 ** ./src/vuex/store.js
 **/